import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBAssociationSetup } from "../../components/WSIBAssociationSetup";

export const WSIBAssociationSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Association Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Association Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBAssociationSetup />}
    />
  );
};
